// tools
import { startAnalytics } from '@tools/amplitude'

export default defineNuxtPlugin(() => {
  const { environment, amplitudeServerUrl, amplitudeApiKey, brand } = useRuntimeConfig().public
  const { isDesktop } = useDevice()

  onNuxtReady(() => {
    void startAnalytics({
      apiKey: amplitudeApiKey,
      serverUrl: amplitudeServerUrl,
      environment,
      brand,
      deviceType: isDesktop ? 'desktop' : 'mobile',
    })
  })
})
